
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Ertigacabbookinginpune() {



    const cardData =
    {
        keyword: '  Ertiga Cab Booking in Pune ',
        heading: 'Skyline Cabs: Ertiga Cab Booking in Pune ',
        headingDescription: 'Skyline Cabs offers premium Ertiga on Rent in Pune for a luxurious and spacious travel experience. Perfect for family outings, corporate travel, or outstation trips, our well-maintained Innova Crysta vehicles provide superior comfort, ample luggage space, and a smooth ride. With experienced chauffeurs, flexible rental plans, transparent pricing, and 24/7 customer support, Skyline Cabs ensures your journey is safe and stress-free. Book your Innova Crysta in Pune today and enjoy premium travel with complete peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Ertiga Rent per km in Pune",
      "description": "Skyline Cabs offers Ertiga rentals in Pune at competitive per-kilometer rates ranging from ₹13 to ₹15, ideal for outstation trips, family travel, or group tours. Transparent billing, no hidden charges, and driver allowance included in long-distance trips."
    },
    {
      "name": "Ertiga Cab Booking in Pune",
      "description": "Book your Ertiga cab in Pune with Skyline Cabs for a spacious and comfortable ride. Perfect for 6-7 passengers, the Ertiga is equipped with AC, ample luggage space, and experienced chauffeurs for local or intercity rides."
    },
    {
      "name": "Book Ertiga Car in Pune",
      "description": "Need an Ertiga in Pune? Skyline Cabs provides easy online and phone booking options. Choose hourly rentals, one-way trips, or round trips with flexible schedules and prompt customer support."
    },
    {
      "name": "Pune to Outstation Ertiga Cab",
      "description": "Plan your next weekend getaway or business trip with Skyline’s Ertiga outstation service from Pune. Well-suited for hill stations, religious tours, and city hops with comfort and affordability."
    },
    {
      "name": "New Ertiga Cab Booking in Pune",
      "description": "Travel in style with Skyline Cabs' fleet of new Ertiga models in Pune. Book easily for weddings, business tours, and family functions. All cabs are well-maintained and sanitized regularly."
    },
    {
      "name": "New Ertiga Cab Booking in Pune Contact Number",
      "description": "For new Ertiga bookings in Pune, contact Skyline Cabs at +91-XXXXXXXXXX. Our support team is available 24x7 to help with rates, availability, and custom travel plans."
    },
    {
      "name": "New Ertiga Cab Booking in Pune Contact Number Hadapsar",
      "description": "Need an Ertiga from Hadapsar? Call Skyline Cabs’ Hadapsar support at +91-XXXXXXXXXX for quick Ertiga bookings in the area with assured vehicle quality and punctual service."
    },
    {
      "name": "Ertiga Cab Booking in Kharadi",
      "description": "Skyline Cabs provides dedicated Ertiga cab booking services in Kharadi, Pune. Great for IT professionals, business visits, and daily commutes, with quick pickup and drop facilities."
    },
    {
      "name": "Ertiga Cab Booking in Hinjewadi",
      "description": "Book an Ertiga from Hinjewadi with Skyline Cabs for IT park transfers, corporate travel, or outstation journeys. Our cabs are well-suited for tech professionals and family use alike."
    },
    {
      "name": "Pune to Mahabaleshwar Ertiga Cab",
      "description": "Planning a trip to Mahabaleshwar? Book a Skyline Ertiga cab for a scenic, comfortable ride from Pune to Mahabaleshwar. Best for families or groups, with hill-route experienced drivers."
    },
    {
      "name": "7 Seater Car on Rent in Pune",
      "description": "Skyline Cabs offers 7-seater vehicles like the Ertiga on rent in Pune for local and long-distance travel. Spacious, clean, and reliable, these cars are perfect for group outings or corporate use."
    },
    {
      "name": "8 Seater Car on Rent in Pune",
      "description": "Looking for something bigger than an Ertiga? Skyline provides 8-seater options like Toyota Innova and tempo travelers on rent in Pune with licensed drivers and flexible travel plans."
    },
    {
      "name": "Ertiga Cab Booking in Baner Aundh",
      "description": "Skyline Cabs serves Baner and Aundh areas with Ertiga cab bookings. Ideal for college students, IT professionals, and residents heading outstation or needing regular commutes."
    },
    {
      "name": "Ertiga Car on Rent in Pune",
      "description": "Rent an Ertiga from Skyline Cabs in Pune for your next city or intercity journey. Daily rental, hourly rental, and weekend packages available at the best market rates."
    },
    {
      "name": "Pune Darshan Ertiga Cab Booking",
      "description": "Explore Pune in comfort with an Ertiga cab from Skyline Cabs. Our Pune Darshan package includes popular landmarks, temples, museums, and more with a private cab and driver."
    },
    {
      "name": "Ertiga Cab Rentals in Pune",
      "description": "Skyline Cabs offers daily and hourly Ertiga cab rentals in Pune. Whether you need it for weddings, outstation trips, or corporate purposes, we’ve got you covered."
    },
    {
      "name": "Cab for Outstation Journey",
      "description": "Choose Skyline Cabs for your outstation journeys from Pune. Our Ertiga and Innova fleets are equipped for long drives, with comfortable seating, courteous drivers, and budget-friendly plans."
    },
    {
      "name": "Hire Ertiga Cab for Outstation",
      "description": "Hire an Ertiga cab from Skyline Cabs for outstation travel from Pune to destinations like Mumbai, Lonavala, Nashik, Goa, or Kolhapur. Fixed rates and reliable drivers guaranteed."
    }
  ],
  "tableData": [
    ["Ertiga Rent per km in Pune", "Ertiga Cab Booking in Pune"],
    ["Book Ertiga Car in Pune", "Pune to Outstation Ertiga Cab"],
    ["New Ertiga Cab Booking in Pune", "New Ertiga Cab Booking in Pune Contact Number"],
    ["New Ertiga Cab Booking in Pune Contact Number Hadapsar", "Ertiga Cab Booking in Kharadi"],
    ["Ertiga Cab Booking in Hinjewadi", "Pune to Mahabaleshwar Ertiga Cab"],
    ["7 Seater Car on Rent in Pune", "8 Seater Car on Rent in Pune"],
    ["Ertiga Cab Booking in Baner Aundh", "Ertiga Car on Rent in Pune"],
    ["Pune Darshan Ertiga Cab Booking", "Ertiga Cab Rentals in Pune"],
    ["Cab for Outstation Journey", "Hire Ertiga Cab for Outstation"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Ertiga Cab Booking in Pune",
        "WhyChoosedescription": "We offer trusted and timely Ertiga cab services in Pune, ideal for city rides, airport transfers, corporate travel, and weekend getaways."
    },
    {
        "WhyChooseheading": "Spacious and Family-Friendly Comfort",
        "WhyChoosedescription": "The Ertiga is perfect for families and small groups, offering 6–7 comfortable seats, air-conditioning, and smooth rides for city or outstation trips."
    },
    {
        "WhyChooseheading": "Well-Maintained and Clean Vehicles",
        "WhyChoosedescription": "Our Ertiga cabs are regularly serviced and sanitized before every ride to ensure a hygienic and reliable experience for every passenger."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "All drivers are experienced, well-behaved, and knowledgeable about Pune’s routes and destinations to ensure safe and smooth travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy fair and fixed pricing with no hidden charges. Our Ertiga cab rates in Pune are designed to suit your budget without compromising comfort."
    },
    {
        "WhyChooseheading": "Flexible Booking Options",
        "WhyChoosedescription": "Book your Ertiga cab for hourly, daily, or long-distance travel. Our flexible packages meet both short-term and full-day needs across Pune and beyond."
    },
    {
        "WhyChooseheading": "24/7 Availability and Support",
        "WhyChoosedescription": "Our cab booking service is available 24/7 for your convenience. Whether it's early morning travel or a late-night pickup, we’re always ready to serve you."
    },
    {
        "WhyChooseheading": "Ideal for All Travel Needs",
        "WhyChoosedescription": "From airport drops to business meetings, sightseeing trips to family functions, the Ertiga is the right blend of comfort, space, and economy."
    }
]






















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book an Ertiga cab in Pune with Skyline Cabs?',
            answer:
                'Booking an Ertiga cab in Pune is easy with Skyline Cabs. You can reserve your ride through our website, mobile app, or by contacting our customer support team. Just enter your trip details, select Ertiga, and confirm your booking.',
        },
        {
            id: 2,
            question: 'Why should I choose an Ertiga for travel in Pune?',
            answer:
                'Ertiga offers a perfect blend of comfort, space, and fuel efficiency, making it ideal for family outings, group travel, airport transfers, and outstation trips from Pune.',
        },
        {
            id: 3,
            question: 'Is the Ertiga available for both local and outstation rides in Pune?',
            answer:
                'Yes, you can book an Ertiga for local travel within Pune as well as for outstation trips to destinations like Mumbai, Lonavala, Mahabaleshwar, and more.',
        },
        {
            id: 4,
            question: 'Are there fixed rates for Ertiga cab bookings in Pune?',
            answer:
                'Yes, Skyline Cabs offers transparent and fixed pricing for Ertiga cab bookings. Your fare includes driver charges, tolls, and taxes with no hidden costs.',
        },
        {
            id: 5,
            question: 'Can I book an Ertiga for a one-way trip from Pune?',
            answer:
                'Absolutely! One-way trips are available for Ertiga bookings from Pune to major cities like Mumbai, Nashik, and Shirdi.',
        },
        {
            id: 6,
            question: 'Can I book an Ertiga for corporate or group travel?',
            answer:
                'Yes, Ertiga is a great option for corporate travel and small group trips. It offers ample space and comfort for team members and clients.',
        },
        {
            id: 7,
            question: 'Are the Ertiga cabs clean and well-maintained?',
            answer:
                'All our vehicles, including Ertiga, are regularly serviced, cleaned, and sanitized to ensure passenger safety and comfort.',
        },
        {
            id: 8,
            question: 'What payment options are available for Ertiga cab bookings in Pune?',
            answer:
                'You can pay via UPI, debit/credit cards, net banking, or in cash at the end of your trip. We ensure secure and flexible payment options for your convenience.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my Ertiga cab booking?',
            answer:
                'Yes, you can modify or cancel your booking easily via our app, website, or customer support. We offer flexible terms to suit your travel needs.',
        },
        {
            id: 10,
            question: 'Why should I book an Ertiga with Skyline Cabs in Pune?',
            answer:
                'Skyline Cabs offers reliable service, professional drivers, and well-maintained Ertiga vehicles. We ensure a smooth, safe, and comfortable journey every time.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Booked an Ertiga in Pune with Skyline Cabs for a weekend getaway. The car was spacious, clean, and the driver was very polite. Great service!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Used Skyline Cabs’ Ertiga service for an airport drop. The ride was smooth and punctual. Would definitely use again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Cab Booking in Pune",
  "image": "https://skylinecabs.com/assets/images/ertiga-cab-booking-pune.jpg",
  "description": "Book Ertiga cab in Pune with Skyline Cabs for spacious and comfortable travel. Ideal for family outings, airport transfers, and outstation rides—available 24/7 with verified drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8024"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/ertiga-cab-booking-in-pune"
  }
};


      
     


    return (
        <div>


<Helmet>
  <title>Ertiga Cab Booking in Pune | 6‑Seater Cab 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Ertiga cab in Pune with Skyline Cabs for spacious and comfortable travel. Ideal for family outings, airport transfers, and outstation rides—available 24/7 with verified drivers." 
  />
  <meta 
    name="keywords" 
    content="Ertiga Cab Booking in Pune, Ertiga Taxi Pune, 6 Seater Cab Pune, AC SUV Cab Pune, Family Cab Booking Pune, Pune Ertiga Rental with Driver, Outstation Ertiga Pune, Airport Cab Pune, Skyline Cabs Ertiga Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/66.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ertigacabbookinginpune;